import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Overview', path: '/overview' },
    { name: 'Our Approach', path: '/approach' },
    { name: 'Our Services', path: '/services' },
    { name: 'Resources', path: '/resources' },
    { name: 'Careers', path: '/careers' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/80 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-3 hover:scale-105 transition-transform duration-200"
          >
            <div className="h-12 w-12 bg-white rounded-full flex items-center justify-center flex-shrink-0">
              <img 
                src="https://customer-assets.emergentagent.com/job_forai-portfolio/artifacts/f1qjy67i_AI4SUSTAINABILITY_MAHENDRA.png" 
                alt="Centre for Sustainable AI Logo" 
                className="h-10 w-10 object-contain"
              />
            </div>
            <div className="text-xl font-light tracking-tight">
              <span className="font-normal">The Centre for</span>
              <br />
              <span className="font-light">Sustainable AI</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm hover:translate-y-[-2px] transition-all duration-200 ${
                  location.pathname === item.path
                    ? 'text-black font-medium'
                    : 'text-gray-600 hover:text-black'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Link to="/contact">
              <Button
                variant="default"
                className="hover:scale-105 transition-transform duration-200"
              >
                Contact Us
              </Button>
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <nav className="lg:hidden pb-6 animate-in fade-in slide-in-from-top-5 duration-200">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`block py-3 text-sm ${
                  location.pathname === item.path
                    ? 'text-black font-medium'
                    : 'text-gray-600'
                }`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)}>
              <Button variant="default" className="mt-4 w-full">
                Contact Us
              </Button>
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;